import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage, showFiservDataGridMessages } from "helpers";
import { merchantInfoService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type ProcessorFieldValuesProps = {
	processor: string;
};

type ProcessorFieldMutationProps = {
	id: number;
	values: ProcessorFieldValuesProps;
	onSuccessHandler?: Function;
};

const useProcessorFieldMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id, values }: ProcessorFieldMutationProps) => {
			return merchantInfoService.editProcessorField(id, values.processor);
		},
		{
			onSuccess(data, { onSuccessHandler }) {
				showFiservDataGridMessages(
					data?.applied_fiserv_grids,
					data?.application_number,
					dispatch,
				);

				dispatch(
					uiActions.showSuccessNotification({
						title: "Field Processor has been updated successfully",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useProcessorFieldMutation;
